import styled from 'styled-components';

export const Pre = styled.pre`
  text-align: left;
  margin: 1em 0;
  padding: 0.5em;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.09);
  font-family: 'Source Code Pro', Consolas, 'Lucida Console', 'Liberation Mono', Menlo, 'Courier New', monospace;
  font-weight: 400;
  overflow-x: auto;

  & .token-line {
    line-height: 1.6em;
    height: 1.6em;
  }
`;

export const LineNo = styled.span`
  display: inline-block;
  width: 2.4em;
  user-select: none;
  opacity: 0.24;
  text-align: right;
  padding-right: 0.8em;
`;
